import { render } from "./Variety_detail_edit.vue?vue&type=template&id=a8415bc6&scoped=true"
import script from "./Variety_detail_edit.vue?vue&type=script&lang=js"
export * from "./Variety_detail_edit.vue?vue&type=script&lang=js"

import "./Variety_detail_edit.vue?vue&type=style&index=0&id=a8415bc6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8415bc6"]])

export default __exports__